import { render, staticRenderFns } from "./StoreExtRvTypeManage.vue?vue&type=template&id=53913e44&scoped=true&"
import script from "./StoreExtRvTypeManage.vue?vue&type=script&lang=js&"
export * from "./StoreExtRvTypeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53913e44",
  null
  
)

export default component.exports